import { objectSchemaOf, Joi, actionCreator } from '../helpers';

export const PING = 'APPS/PING';

export const pingPayloadSchema = objectSchemaOf<IPingPayload>({
  id: Joi.string().required(),
  timestamp: Joi.number().required(),
});

export const pingActionSchema = objectSchemaOf<IPingAction>({
  type: Joi.string().required().valid(PING),
  payload: pingPayloadSchema.required(),
});

export interface IPingPayload {
  id: string;
  timestamp: number;
}

export interface IPingAction {
  type: typeof PING;
  payload: IPingPayload;
}

export const ping = actionCreator({
  type: PING,
  schema: pingActionSchema,
});
